export default class PasswordStrength {

  constructor() {
    const zxcvbnUrl =  '//common-admin-cdn.atlassian.com/zxcvbn/f2a8cda/zxcvbn.js';

    return {
      init: function() {
        // @ts-ignore
        if (typeof window.zxcvbn === 'undefined') {
          // load zxcvbn script
          let zxcvbnScript = document.createElement('script');
          zxcvbnScript.type = 'text/javascript';
          zxcvbnScript.charset = 'utf-8';
          zxcvbnScript.async = true;
          zxcvbnScript.src = zxcvbnUrl;
          document.getElementsByTagName("head")[0].appendChild(zxcvbnScript);
        }
      },

      evaluatePasswordStrength: function(val) {
        return typeof window.zxcvbn !== 'undefined' ? window.zxcvbn(val).score : null;
      },

    };
  }
}
